import { useSyncExternalStore } from "react";
import { getBuildDate } from "../utils/bestOfMonth";

const subscribe = () => () => {};
// The prerendered HTML and the first client render both see the build date; after hydration the visitor's clock takes over.
const getServerNow = () => getBuildDate().getTime();
const getClientNow = () => Math.floor(Date.now() / 60000) * 60000;

export default function useNow() {
  return useSyncExternalStore(subscribe, getClientNow, getServerNow);
}
